import { OmniaApiState } from "../../api/apiState"
import { HoldingEvent, OmniaEvent } from "../../api/types"
import { OmniaModuleId, OmniaObjectType } from "../../generated/enums"
import { labels } from "../../generated/labels"
import { IOmniaShell } from "../../shell"
import { defineDirective } from "../../utils/angular"
import { EventInfoService } from "./eventInfoService"
import { EventText, getActivityTextProvider, getEventTextProvider } from "./eventText"
import { createSessionsVm, SessionVm } from "./sessions"
import { showEditDialog as showHoldingPermissionsEditDialog } from "../../../shared_esm"
import { hasOwnerLikeRole } from "@omnia/shared/session/utils"

/** @internal */
export class PopupCtrl {

    static create() {
        return defineDirective(PopupCtrl, "shared/main/notifications/popup.html", {
            view: "=",
            isOpen: "="
        })
    }

    private eventTextProvider: (event: HoldingEvent) => EventText
    eventTexts: { [id: number]: EventText } = {}

    private activityTextProvider: (event: OmniaEvent) => EventText

    view: "sessions" | "events"

    isOpen: boolean

    sessions: SessionVm[]
    events: HoldingEvent[]
    showDetails = false

    static $inject = ["$scope", "OmniaShell", "OmniaApiState", "OmniaEventInfo"]

    constructor(
        private readonly $scope: ng.IScope,
        private readonly shell: IOmniaShell,
        private readonly apiState: OmniaApiState,
        private readonly eventInfo: EventInfoService,
        private readonly session = shell.getSession()
    ) {

    }

    get showEvents() {
        return this.view == "events"
    }

    get showSessions() {
        return this.view == "sessions"
    }

    $onInit() {

        this.$scope.$watch("vm.apiState.sessions", () => this.refreshSessions())
        this.$scope.$watch("vm.apiState.events", () => this.refreshEvents())

        this.$scope.$on("omnia.refresh", () => this.refresh())

        this.refresh()



    }

    canEditPermissions() {
        const { shell, session } = this
        if (shell.disableMenu) return false
        return hasOwnerLikeRole(session)
    }

    editPermissions() {
        this.isOpen = false
        showHoldingPermissionsEditDialog(this.shell)
    }

    private refresh() {

        this.eventInfo.ensureInitialized().then(() => {

            this.eventTexts = {}
            this.eventTextProvider = getEventTextProvider(this.eventInfo)

            this.activityTextProvider = getActivityTextProvider(this.eventInfo)

        })

    }

    private refreshSessions() {
        this.sessions = createSessionsVm(this.apiState.sessions, this.session.holdingUsers, this.activityTextProvider)
    }

    private refreshEvents() {
        this.events = [...this.apiState.events.events]
    }

    getDateText(date: Date) {

        const short = 1000 * 60 * 60 * 12
        const diff = Date.now() - date.valueOf()

        return (diff < short)
            ? date.toLocaleTimeString()
            : date.toLocaleDateString(undefined, { day: "2-digit", month: "2-digit", year: undefined })
    }

    getEventSourceText(e: OmniaModuleId) {
        return labels.OmniaModuleId(e)
    }

    getEventTypeText(e: OmniaObjectType) {
        return labels.OmniaObjectType(e)
    }

    getEventText(e: HoldingEvent) {

        const { eventTexts, eventTextProvider } = this

        let t = eventTexts[e.Id]

        if ((!t) && eventTextProvider) {

            t = eventTexts[e.Id] = eventTextProvider(e)

        }

        return t?.text

    }

}
